// extracted by mini-css-extract-plugin
module.exports = {"grid":"InputItem_grid__SvyZc","label":"InputItem_label__2ORdP","input":"InputItem_input__3qmfp"};